export default __webpack_public_path__ + "static/logo-bg-499cca75c90d96791ac82a931a4fd844.png";